import _ from 'underscore';
import Backbone from 'backbone';

import SearchItemModel from './model';

export default Backbone.Collection.extend({
	highlightedIndex: -1,
	model: SearchItemModel,
	url: '/override-this',

	initialize: function(models, options) {
		// Event listeners
		this.listenTo(this, 'reset', this.onReset);
		this.listenTo(this, 'change:IsSelected', this.onSelectedChange);
	},

	/**
	 * Private
	 * Trigger 'remove' event on the previous models, so that connected views can be removed
	 **/
	onReset: function(collection, options) {
		this.setHighlightedIndex();

		_.each(options.previousModels, function(model) {
			model.trigger('remove');
		});
	},

	/**
	 * model IsSelected change handler
	 **/
	onSelectedChange: function(modelSelected, isSelected) {

		// only process if an item is selected (do nothing by deselect)
		if (isSelected === true) {
			this.models.forEach(function(model) {
				// deselect all other models
				if (model.id !== modelSelected.id) {
					model.set('IsSelected', false);
				}
			});
		}
	},

	/**
	 * highlight next item in list
	 **/
	highlightNext: function() {
		var index = this.getHighlightedIndex();

		// Nothing selected or index will be higher than the number of results
		index = (index === -1 || index + 1 >= this.length) ? 0 : index + 1;

		return this.highlight(index);
	},

	/**
	 * highlight previous item in list
	 **/
	highlightPrevious: function() {
		var index = this.getHighlightedIndex();

		// Nothing selected or index will be less than zero
		index = (index === -1 || index - 1 < 0) ? this.length - 1 : index - 1;

		return this.highlight(index);
	},

	/**
	 * returns highlight index
	 **/
	getHighlightedIndex: function() {
		return this.highlightedIndex;
	},

	/**
	 * set highlight index
	 **/
	setHighlightedIndex: function(index) {
		index = typeof index === 'undefined' ? -1 : index;
		this.highlightedIndex = index;
	},

	/**
	 * Unhighlight current item
	 * Highlight item at index
	 **/
	highlight: function(index) {
		var current = this.getHighlighted(),
			next = this.at(index);

		if (current) {
			current.set('IsHighlighted', false);
		}

		// Update the select index
		this.setHighlightedIndex(index);

		// Select next
		next.set('IsHighlighted', true);

		return next;
	},

	/**
	 * get currently highlighted model
	 **/
	getHighlighted: function() {
		return this.findWhere({'IsHighlighted': true});
	},

	/**
	 * Get the selected model
	 **/
	getSelected: function() {
		return this.findWhere({'IsSelected': true});
	},

	/**
	 * set the selected model
	 **/
	setSelected: function(model) {
		model.set('IsSelected', true);
	}
});
